import { render, staticRenderFns } from "./UiNumberInput.vue?vue&type=template&id=cfbbe33a&scoped=true&"
import script from "./UiNumberInput.vue?vue&type=script&lang=js&"
export * from "./UiNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./UiNumberInput.vue?vue&type=style&index=0&id=cfbbe33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbbe33a",
  null
  
)

export default component.exports